/**
 * Elivora seasonal sale labels, from deployment through 2027-01-18.
 * Only promotional WORDS change. The countdowns, prices, savings,
 * bundle logic and checkout flows are not modified.
 *
 * All sale dates are inclusive in the storefront's US Eastern timezone.
 * From 19 January 2027 onward the pre-Fall "SPRING SALE" text is restored.
 * If the original pre-Fall campaign was different, edit DEFAULT_SALE here.
 */
(function () {
  'use strict';

  if (window.ElivoraSeasonalSaleText && window.ElivoraSeasonalSaleText.installed) return;

  const STORE_TIME_ZONE = 'America/New_York';
  const DEFAULT_SALE = 'SPRING SALE';
  const SALE_STAGES = [
    { from: 0,        to: 20261114, name: 'EARLY BLACK FRIDAY SALE' },
    { from: 20261115, to: 20261204, name: 'BLACK FRIDAY SALE' },
    { from: 20261205, to: 20261225, name: 'CHRISTMAS SALE' },
    { from: 20261226, to: 20270118, name: 'NEW YEAR SALE' }
  ];
  const SALE_WORDS = /\b(?:EARLY BLACK FRIDAY SALE|BLACK FRIDAY SALE|CHRISTMAS SALE|NEW YEAR SALE|FALL SALE|SPRING SALE)\b/gi;
  const TARGETS = [
    '.pdp-sale-banner-v3__heading',         // Timer banner text only (NOT digits)
    '.pdp-sale-banner-v3__subheading',
    '.promo-countdown-content h2',          // Legacy promo timer text only
    '.pdp-announcement-bar__headline',
    '.announcement-bar__scrolling-list p', // Header announcement in scrolling mode
    '.announcement-bar__static-list p',    // Header announcement in static mode
    '.timer_parent_div .text_timer',       // Old seasonal countdown label ONLY
    '.mpv1-rpp__price-bar-badge',          // V1 price badge; JS keeps savings
    '.js-mpv3-price-sale'                  // V3 price badge; JS keeps savings
  ].join(',');

  const shopDateFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: STORE_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });

  function dateKey(date) {
    const parts = shopDateFormatter.formatToParts(date);
    const values = {};
    parts.forEach(function (part) {
      if (part.type === 'year' || part.type === 'month' || part.type === 'day') {
        values[part.type] = Number(part.value);
      }
    });
    return values.year * 10000 + values.month * 100 + values.day;
  }

  function saleNameFor(date) {
    const key = dateKey(date || new Date());
    const stage = SALE_STAGES.find(function (item) {
      return key >= item.from && key <= item.to;
    });
    return stage ? stage.name : DEFAULT_SALE;
  }

  function replaceSaleWords(text, newSaleName) {
    if (typeof text !== 'string' || !text) return text;
    return text.replace(SALE_WORDS, function (match) {
      // Preserve the original uppercase/Title Case styling.
      return match === match.toUpperCase()
        ? newSaleName
        : newSaleName.toLowerCase().replace(/\b[a-z]/g, function (ch) { return ch.toUpperCase(); });
    });
  }

  function refreshElement(element, label) {
    if (!element || element.nodeType !== 1) return;

    // Keep V1's live calculated "$..." saving intact across plan changes.
    if (element.matches('.mpv1-rpp__price-bar-badge') && element.hasAttribute('data-prefix')) {
      const originalPrefix = element.getAttribute('data-prefix');
      const updatedPrefix = replaceSaleWords(originalPrefix, label);
      if (updatedPrefix !== originalPrefix) element.setAttribute('data-prefix', updatedPrefix);
    }

    // V3's pack-selection code reads data-sale-template on each price update.
    // Update the template, never recalculate the actual discount or price.
    if (element.matches('.js-mpv3-price-sale') && element.hasAttribute('data-sale-template')) {
      const originalTemplate = element.getAttribute('data-sale-template');
      const updatedTemplate = replaceSaleWords(originalTemplate, label);
      if (updatedTemplate !== originalTemplate) element.setAttribute('data-sale-template', updatedTemplate);
    }

    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const updatedText = replaceSaleWords(node.nodeValue, label);
      if (updatedText !== node.nodeValue) node.nodeValue = updatedText;
    }
  }

  function refresh(root) {
    const label = saleNameFor(new Date());
    if (!root || !root.querySelectorAll) return;
    if (root.nodeType === 1 && root.matches && root.matches(TARGETS)) {
      refreshElement(root, label);
    }
    root.querySelectorAll(TARGETS).forEach(function (element) {
      refreshElement(element, label);
    });
  }

  function installObserver() {
    // Replace changed labels when Shopify re-renders a section, or when a
    // bundle-selection script re-renders the price badge's text node.
    const observer = new MutationObserver(function (records) {
      const label = saleNameFor(new Date());
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            const owner = record.target.nodeType === 1 ? record.target.closest(TARGETS) : null;
            if (owner) refreshElement(owner, label);
            refresh(node);
          } else if (node.nodeType === 3 && record.target && record.target.nodeType === 1) {
            const parent = record.target.closest(TARGETS);
            if (parent) refreshElement(parent, label);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    refresh(document);
    installObserver();
    // Refresh if a visitor stays on the same page over a date boundary.
    window.setInterval(function () { refresh(document); }, 60000);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refresh(document);
    });
    window.addEventListener('pageshow', function () { refresh(document); });
    document.addEventListener('shopify:section:load', function (event) {
      refresh(event.target);
    });
  }

  window.ElivoraSeasonalSaleText = {
    installed: true,
    saleNameFor: saleNameFor,
    replaceSaleWords: replaceSaleWords,
    refresh: refresh,
    timeZone: STORE_TIME_ZONE
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
